import { useLoadScript } from '@react-google-maps/api';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

let preLocale: string | undefined;
export function useGoogleMapScript() {
    const router = useRouter();
    useEffect(() => {
        if (window?.google && preLocale !== router.locale) {
            //fix error:"You have included the Google Maps JavaScript API multiple times on this page"
            (window as any).google = {};
        }
        preLocale = router.locale;
    }, [router.locale]);
    return useLoadScript({
        language: router.locale,
        googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
    });
}
